// extracted by mini-css-extract-plugin
export default {"Line":"Line_Line__hb2K0","Yellow":"Line_Yellow__ncFCe"};